import Cookies from "js-cookie";
import axios from "axios";
import { store } from "@/redux/store";
import { logout } from "@/redux/features/auth-slice";

const apiClient = axios.create({
  baseURL: "",
});

const PUBLIC_PATH_PREFIXES = [
  "/login",
  "/signup",
  "/request-signup",
  "/complete-signup",
  "/forgot-password",
  "/update-forgotten-password",
  "/complete-login",
  "/enable-2fa",
  "/disable-2fa",
  "/super-admin/login",
];

function isPublicPath(pathname: string): boolean {
  return PUBLIC_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

apiClient.interceptors.request.use(
  (config: any) => {
    // Regular-user tokens are httpOnly (attached server-side by /api/[...path]) — this only ever
    // finds a value for the super-admin flow, which still manages its own client-readable cookie.
    const superAdminToken = Cookies.get("super_admin_access_token");
    if (superAdminToken && !config.headers?.Authorization) {
      config.headers["Authorization"] = `Bearer ${superAdminToken}`;
    }

    if (config.data instanceof FormData) {
      // For FormData, don't set Content-Type - let the browser set it with boundary
      config.headers = {
        ...config.headers,
      };
    } else {
      config.headers = {
        ...config.headers,
        "Content-Type": "application/json",
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error: any) => {
    const status = error.response?.status ?? error.status;
    if (status === 401) {
      // The proxy has already attempted a server-side refresh by the time we see this,
      // a 401 here means the session is genuinely gone. Clear locally cached user data
      // and send the user back to the login page instead of leaving them stranded.
      localStorage.clear();
      store.dispatch(logout());

      if (typeof window !== "undefined" && !isPublicPath(window.location.pathname)) {
        const onSuperAdminApp = window.location.pathname.startsWith("/super-admin");
        if (onSuperAdminApp) {
          Cookies.remove("super_admin_access_token", { path: "/" });
          Cookies.remove("super_admin_refresh_token", { path: "/" });
          window.location.href = "/super-admin/login";
        } else {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);
export default apiClient;
